import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ChamadoSuporte } from 'src/app/admihair/api/dto/chamado-suporte';
import { Table } from 'primeng/table';
import { ChamadoSuporteService } from 'src/app/admihair/service/chamado-suporte.service';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { LazyLoadEvent, SelectItem } from 'primeng/api';

@Component({
  selector: 'app-chamado-franquia-listar',
  templateUrl: './chamado-franquia-listar.component.html',
  styleUrls: ['./chamado-franquia-listar.component.scss']
})
export class ChamadoFranquiaListarComponent extends AdmihairBaseComponent implements OnInit {


  loading: boolean = true;
  loadingNovoChamado: boolean = true;

  listaChamadoSuporte: ChamadoSuporte[] = [];

  itensPaginados?: Paginador<ChamadoSuporte>;
  numeroPagina: number = 0;
  inputBusca?: string = '';
  ordenacao: string = 'dataCriacao,DESC';
  tamanhoPagina: number = 10;


  listaStatus: SelectItem[] = [
    { label: 'TODOS', value: 'TODOS' },
    { label: 'ABERTOS', value: 'ABERTO' },
    { label: 'RECEBIDOS', value: 'RECEBIDO' },
    { label: 'EM ATENDIMENTO', value: 'EM_ATENDIMENTO' },
    { label: 'ENCERRADOS', value: 'ENCERRADO' }
  ]

  statusSelecionado: string = 'ABERTO';

  listaFiltroSolicitado: SelectItem[] = [
    { label: 'Recebido', value: 'FRANQUIA' },
    { label: 'Enviado', value: 'EMPRESA' }
  ];
  solicitadoSelecionado: string = 'FRANQUIA';

  listaTiposAtendimento: SelectItem[] = [
    { label: 'TODOS', value: 'TODOS' },
    { label: 'ERRO', value: 'ERRO' },
    { label: 'DÚVIDA', value: 'DUVIDA' },
    { label: 'SOLICITAÇÃO DE FUNCIONALIDADE', value: 'SOLICITACAO_FUNCIONALIDADE' },
    { label: 'PROBLEMA DE DESEMPENHO', value: 'PROBLEMA_DESEMPENHO' },
    { label: 'ACESSO/PERMISSÃO', value: 'ACESSO_PERMISSAO' },
    { label: 'TREINAMENTO/CAPACITAÇÃO', value: 'TREINAMENTO_CAPACITACAO' },
    { label: 'INSTALACÃO/CONFIGURAÇÃO', value: 'INSTALACAO_CONFIGURACAO' },
    { label: 'SOLICITAÇÃO DE DOCUMENTO', value: 'SOLICITACAO_DOCUMENTO' },
    { label: 'SOLICITAÇÃO DE INFORMAÇÕES COMPLEMENTARES', value: 'SOLICITACAO_INFORMACOES_COMPLEMENTARES' },
    { label: 'OUTRO', value: 'OUTRO' },
  ]
  tipoAtendimentoSelecionado: string = 'TODOS';

  constructor(private chamadoSuporteService: ChamadoSuporteService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router?: Router,
    activatedRoute?: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
  }


  carregarChamados() {
    this.loading = true;
    this.chamadoSuporteService.listarPorAdministradora(
      this.getAdministradora().id,
      this.numeroPagina,
      this.tamanhoPagina,
      this.ordenacao,
      this.inputBusca,
      this.statusSelecionado,
      this.solicitadoSelecionado,
      this.tipoAtendimentoSelecionado
    ).subscribe({
      next: (data: Paginador<ChamadoSuporte>) => {
        this.itensPaginados = data;
        this.listaChamadoSuporte = data.content;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  marcarComoRecebido(chamadoId: number) {
    const status = 'RECEBIDO';
    this.chamadoSuporteService.atualizarSituacaoChamado(chamadoId, status).subscribe({
      next: () => {
        this.carregarChamados();
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })

  }



  onLazyLoad(event: LazyLoadEvent) {
    if (event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    this.definirOrdenacao(event.sortField, event.sortOrder);
    this.loading = true;
    this.carregarChamados();
  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    if (sortField && sortOrder) {
      const campoDeOrdenacao = sortField ? sortField : 'dataCriacao';
      const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
      this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
    } else {
      this.ordenacao = 'dataCriacao,DESC';
    }
  }

  alterarFiltro(table: Table) {
    table.clear();
  }

  buscar(table: Table, event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.numeroPagina = 0;
    table.clear();
  }

  limpar(table: Table) {
    this.inputBusca = '';
    this.statusSelecionado = 'ABERTO';
    table.reset();
  }

}
